import {Component} from '@angular/core';
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-parent',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./parent.component.scss'],
  standalone: true,
  imports: [
    RouterOutlet,
  ]
})
export class ParentComponent {

}
